import { init } from './init'
import { sanitizeData, sanitizeExpire } from './Sanitize'

const actionTypes = {
  FETCH_MEMBER: 'FETCH_MEMBER',
  CLEAR_DATA: 'CLEAR_DATA',
}

const fetchMember = async (state, member) => {
  state = {
    ...state,
    isStatus: member.status,
    expireToken: sanitizeExpire({
      status: member.status,
      data: member.data,
      name: 'memberObject',
    }),
    data: sanitizeData({
      status: member.status,
      data: member.data,
      name: 'memberObject',
    }),
  }
  return state
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_MEMBER:
      return fetchMember(state, action.member)
    case actionTypes.CLEAR_DATA:
      return init
    default:
      return state
  }
}

const member = {
  init,
  actionTypes,
  reducer,
}

export default member
